import React, { Fragment, useEffect, useState } from 'react';
import { fetchGetCounteragents } from '../../actions/settings';
import Select from './Select';
import { components } from 'react-select';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .edit-indicator {
    padding: 8px;
    line-height: 1;

    i {
      font-size: 18px;
      line-height: 1;
      width: 20px;
      height: 20px;
    }
  }
`;

const IndicatorsContainer = (props) => {
  const { children, ...passedProps } = props;

  const {
    getValue,
    selectProps: { handleEditCountreagent },
  } = props;

  const value = getValue();
  const countragent = value && value.length ? value[0].data || null : null;

  const handleEditClick = (e) => {
    e.stopPropagation();
    handleEditCountreagent(countragent);
  };

  return (
    <components.IndicatorsContainer {...passedProps}>
      <div
        className="edit-indicator text-primary"
        onClick={handleEditClick}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <i className={countragent ? 'fe-edit' : 'fe-plus-circle'}></i>
      </div>
      {children}
    </components.IndicatorsContainer>
  );
};

const NoOptionsMessage = (props) => {
  const { children, ...passedProps } = props;

  const {
    selectProps: { handleEditCountreagent },
  } = props;

  const handleEditClick = (e) => {
    /*e.stopPropagation();*/
    handleEditCountreagent(null);
  };

  return (
    <components.NoOptionsMessage {...passedProps}>
      Контрагента с указанным наименованием не найдено. Хотите{' '}
      <a href="javascript:void(0);" onClick={handleEditClick}>
        создать нового
      </a>
      ?
    </components.NoOptionsMessage>
  );
};

const CountragentSelect = (props) => {
  const {
    label,
    value, //Целиком объект контрагент
    withoutIndicators = false,
    onChange,

    //Вызывается при нажатии кнопки создания/редактирования контрагента. Параметр - текущий выбранный контрагент. null- если контрагент не выбран и кнопка должна работать в режиме нового. Было бы лучше прямо из этого компонента открывать попап редактирования контрагента. А после изменения данных пользователем вызывать onChange. Но данный селект может находиться внутри попапа. А сейчас невозможно открыть два попапа одновременно, первый закроется. Т.е. закроется как раз тот в котором находится данный селект. Потеряется контекст и данные не удасться обновить. Поэтому попап редактирования контрагента надо открывать в внешнем по отношению к тому попапу в котором находится селект компоненте.
    handleEditCountreagent,
    onInputChange,
  } = props;

  const dispatch = useDispatch();
  const [cacheCountragentSuggestion, setCacheCountragentSuggestion] = useState([]);

  const { t } = useAutoTranslation();

  const defaultInputValue = '';
  const [inputValue, setInputValue] = useState(value?.value ?? defaultInputValue);

  useEffect(() => {
    if (value?.label) {
      setInputValue(value.label);
    }
  }, [value?.label]);

  useEffect(() => {
    loadCountragentSuggestion((value && value.name) || '');
  }, []);

  const loadCountragentSuggestion = (text) =>
    new Promise(async (resolve) => {
      /*if (text.length > 2){*/
      const result = await dispatch(
        fetchGetCounteragents({
          size: 500,
          ...(text ? { query: text } : {}),
        }),
      );
      const newOptions = result.counteragents.map((c) => ({
        label: c.name,
        value: c.id,
        data: c,
      }));
      setCacheCountragentSuggestion(newOptions);
      resolve(newOptions);
      /*} else {
                resolve([]);
            }*/
    });

  const componentsObj = { NoOptionsMessage };

  if (!withoutIndicators) {
    componentsObj['IndicatorsContainer'] = IndicatorsContainer;
  }

  return (
    <Wrapper>
      <Select
        key={`react-select-${label}`}
        label={label}
        isAsync
        defaultOptions={cacheCountragentSuggestion}
        loadOptions={loadCountragentSuggestion}
        value={{
          label: value && t(value.name),
          value: value && value.id,
          data: value,
        }}
        onChange={(value) => onChange(value && value.data)}
        noOptionsMessage={t('Контрагента с указанным наименованием не найдено')}
        components={componentsObj}
        handleEditCountreagent={handleEditCountreagent}
        onInputChange={onInputChange}
        defaultValue={null}
      />
    </Wrapper>
  );
};

export default CountragentSelect;
